import Assert from 'assert';

// Cycle the hash and re-deploy to forcibly "clear" local storage.
const STORAGE_HASH = 'f48ba5b5-4010-4fbc-b5d2-9a9ed6535850 ';

export const getLocalStorageKey = ({ storeId }) => {
    Assert.strictEqual(typeof storeId, 'string', 'storeId must be a string');
    return `edsights-storage-${storeId}-${STORAGE_HASH}`;
};
